/* Pfirsichhaut – kleine Helfer für das neue Design (ohne Lisa-Code) */
(function () {
  // 1) „Hinzufügen“ in den Warenkorb-Empfehlungen: in den Warenkorb legen und Drawer neu rendern
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-ph-add]');
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    try {
      var res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.phAdd), quantity: 1 }], sections: sections, sections_url: window.location.pathname })
      });
      var data = await res.json();
      if (drawer && data.sections) {
        drawer.renderContents(Object.assign({ id: btn.dataset.phAdd }, data));
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
      if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ph-reco' });
    } catch (err) {
      window.location.href = '/cart';
    }
  });

  // 2) Pflege-Ziel / Frag-Lisa-Kacheln: Ereignis für Lisa senden. Lisa (eigene Entwicklung) hört auf "ph:ask-lisa".
  //    Hört niemand zu, führt der Link zur hinterlegten URL.
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ph-lisa]');
    if (!a) return;
    if (!window.__phLisaListening) return; // ohne Lisa: normaler Link
    e.preventDefault();
    window.dispatchEvent(new CustomEvent('ph:ask-lisa', { detail: { text: a.dataset.phLisa } }));
  });

  // 3) Tabs (Favoriten & Bestseller)
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ph-tab]');
    if (!t) return;
    var root = t.closest('[data-ph-tabs]');
    root.querySelectorAll('[data-ph-tab]').forEach(function (b) { b.setAttribute('aria-selected', b === t ? 'true' : 'false'); });
    root.querySelectorAll('[data-ph-panel]').forEach(function (p) {
      var show = p.dataset.phPanel === t.dataset.phTab;
      var tpl = show && p.querySelector('template[data-ph-tpl]');
      if (tpl) { p.appendChild(document.importNode(tpl.content, true)); tpl.remove(); }
      p.hidden = !show;
    });
  });

  // 4) Glossar: Suche, Stichworte und A–Z über die Einträge der Seite (<details> oder Karten .ph-gl__card)
  function initGlossary(root) {
    var input = root.querySelector('[data-ph-gq]');
    var list = document.querySelectorAll(root.dataset.phGlossary || '.page-width details, .rte details');
    var count = root.querySelector('[data-ph-gcount]');
    var empties = document.querySelectorAll('[data-ph-gempty]');
    var chips = root.querySelectorAll('[data-ph-chip]');
    var letter = null, qv = '';
    function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
    function apply() {
      var q = norm(input ? input.value : qv);
      var n = 0;
      list.forEach(function (d) {
        var head = d.querySelector('summary');
        var name = d.dataset.letter ? d.dataset.letter : (head ? head.textContent.trim() : '');
        var first = norm(name).charAt(0).toUpperCase();
        var ok = (!q || norm(d.textContent).indexOf(q) > -1) && (!letter || first === letter);
        d.hidden = !ok;
        if (ok) n++;
        if (q && ok && head && norm(head.textContent).indexOf(q) > -1) d.open = true;
      });
      if (count) count.textContent = n;
      empties.forEach(function (e) { e.hidden = n > 0; });
      if (!input) chips.forEach(function (b) { b.setAttribute('aria-pressed', qv && norm(b.dataset.phChip) === q ? 'true' : 'false'); });
      if (reset) reset.hidden = !(q || letter);
    }
    var reset = root.querySelector('[data-ph-greset]');
    if (reset) reset.addEventListener('click', function () {
      qv = ''; letter = null; if (input) input.value = '';
      root.querySelectorAll('[data-ph-letter]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      apply();
    });
    if (input) input.addEventListener('input', apply);
    root.querySelectorAll('[data-ph-letter]').forEach(function (b) {
      b.addEventListener('click', function () {
        letter = letter === b.dataset.phLetter ? null : b.dataset.phLetter;
        root.querySelectorAll('[data-ph-letter]').forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.phLetter === letter ? 'true' : 'false'); });
        apply();
      });
    });
    chips.forEach(function (b) {
      b.addEventListener('click', function () {
        if (input) { input.value = b.dataset.phChip; apply(); input.focus(); }
        else { qv = qv === b.dataset.phChip ? '' : b.dataset.phChip; apply(); }
      });
    });
    var q0 = new URLSearchParams(location.search).get('q');
    if (q0) { if (input) input.value = q0; else qv = q0; }
    apply();
    if (q0) {
      var hit = Array.prototype.find.call(list, function (d) { return !d.hidden; });
      if (hit && hit.scrollIntoView) setTimeout(function () { hit.scrollIntoView({ block: 'start' }); }, 50);
    }
  }
  // 5) „Zurück“: zur vorherigen Seite im Shop; kommt man von außen (z. B. Google), gilt der Link (Startseite)
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ph-back]');
    if (!a) return;
    var ref = '';
    try { ref = document.referrer ? new URL(document.referrer).origin : ''; } catch (err) {}
    if (ref === location.origin && history.length > 1) { e.preventDefault(); history.back(); }
  });
  function boot() { document.querySelectorAll('[data-ph-glossary]').forEach(initGlossary); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* Artikel: Inhaltsverzeichnis automatisch aus den H2 des Artikels */
(function () {
  function toc() {
    var src = document.querySelector('[data-ph-toc-source]'), nav = document.querySelector('[data-ph-toc]');
    if (!src || !nav) return;
    var hs = src.querySelectorAll('h2');
    if (hs.length < 2) return;
    var ol = nav.querySelector('ol');
    hs.forEach(function (h, i) {
      if (!h.id) h.id = 'abschnitt-' + (i + 1);
      var li = document.createElement('li'), a = document.createElement('a');
      a.href = '#' + h.id; a.textContent = h.textContent.trim(); li.appendChild(a); ol.appendChild(li);
    });
    nav.hidden = false;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', toc); else toc();
})();

/* Warenkorb: Gratis-Geschenk wählen, wechseln oder entfernen */
(function () {
  function drawer() { return document.querySelector('cart-drawer'); }
  function sections() { var d = drawer(); return d && d.getSectionsToRender ? d.getSectionsToRender().map(function (s) { return s.id; }) : []; }
  function render(data) {
    var d = drawer();
    if (d && data && data.sections) { d.renderContents(data); } else { window.location.reload(); }
    if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ph-gift' });
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  var root = (window.routes && window.routes.root) || '/';
  if (root.slice(-1) !== '/') root += '/';
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-ph-gift-add]');
    var rm = e.target.closest('[data-ph-gift-remove]');
    if (!add && !rm) return;
    e.preventDefault();
    var btn = add || rm;
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var secs = sections();
    var step;
    if (rm) {
      step = post(root + 'cart/change.js', { id: rm.dataset.phGiftRemove, quantity: 0, sections: secs, sections_url: window.location.pathname });
    } else {
      var swap = add.dataset.phGiftSwap;
      var pre = swap ? post(root + 'cart/change.js', { id: swap, quantity: 0 }) : Promise.resolve();
      step = pre.then(function () {
        var item = { id: Number(add.dataset.phGiftAdd), quantity: 1 };
        /* Markierung für den Gratis-Rabatt (Dealeasy „Gratisprodukt“): nur so wird die Zeile 0 € */
        if (add.dataset.phGiftGoal) item.properties = { __dealeasy_gift_product: add.dataset.phGiftGoal };
        return post(root + 'cart/add.js', { items: [item], sections: secs, sections_url: window.location.pathname });
      });
    }
    step.then(function (data) {
      if (data && data.status && data.status >= 400) { btn.removeAttribute('aria-busy'); if (window.console) console.warn('ph-gift', data); return; }
      render(data);
    }).catch(function () { window.location.reload(); });
  });
})();
